import React, { useEffect } from 'react';
import { Alert, Link, Typography, Tooltip, } from '@one-thd/sui-atomic-components';
import { InfoFilled } from '@one-thd/sui-icons';
import { MANAGE_USERS_URL, PAYMENTS_URL } from '../../../constants/links';
import { track } from '../../../utils/analytics';
import { PRO_PAGE_LOAD, PRO_GET_STATE, PRO_GET_POST_PAGE_ERROR, PRO_ALLOWANCE_OVERLAY, } from '../../../constants/analytics';
export var ProAllowMissingDataMsgs = function (_a) {
    var hasExistingUsers = _a.hasExistingUsers, hasExistingPAACards = _a.hasExistingPAACards, hasExistingPmtCards = _a.hasExistingPmtCards;
    var addUserToAccount = !hasExistingUsers && hasExistingPAACards && hasExistingPmtCards;
    var authorizeCard = hasExistingUsers && hasExistingPmtCards && !hasExistingPAACards;
    var addCreditCard = !hasExistingPmtCards && hasExistingUsers;
    var addUserAndCreditCard = !hasExistingPAACards && !hasExistingUsers && !hasExistingPmtCards;
    var addUserAndAuthorizeCard = !hasExistingPAACards &&
        !hasExistingUsers &&
        hasExistingPmtCards &&
        !hasExistingPAACards;
    useEffect(function () {
        if (addUserToAccount) {
            var message = 'You need to add a user to your account to get started with Pro Allowance';
            track(PRO_GET_POST_PAGE_ERROR, {
                displayType: 'inline',
                message: message,
                code: 'n/a',
                type: 'advisory',
                pageSection: PRO_ALLOWANCE_OVERLAY,
            });
            track(PRO_PAGE_LOAD, { pageName: 'no users' });
        }
        if (addCreditCard) {
            var message = 'You need to add a credit card to your account to get started with Pro Allowance';
            track(PRO_GET_POST_PAGE_ERROR, {
                displayType: 'inline',
                message: message,
                code: 'n/a',
                type: 'advisory',
                pageSection: PRO_ALLOWANCE_OVERLAY,
            });
            track(PRO_PAGE_LOAD, { pageName: 'no cards' });
        }
        if (authorizeCard) {
            var message = 'You need to authorize a card for remote purchases to get started with Pro Allowance';
            track(PRO_GET_POST_PAGE_ERROR, {
                displayType: 'inline',
                message: message,
                code: 'n/a',
                type: 'advisory',
                pageSection: PRO_ALLOWANCE_OVERLAY,
            });
            track(PRO_PAGE_LOAD, { pageName: 'no authorized' });
        }
        if (addUserAndCreditCard) {
            var message = 'You need to update your account to get started with Pro Allowance. Add a user to your account. Add a credit card to your account';
            track(PRO_GET_POST_PAGE_ERROR, {
                displayType: 'inline',
                message: message,
                code: 'n/a',
                type: 'advisory',
                pageSection: PRO_ALLOWANCE_OVERLAY,
            });
            track(PRO_PAGE_LOAD, { pageName: 'no users no cards' });
        }
        if (addUserAndAuthorizeCard) {
            var message = 'You need to update your account to get started with Pro Allowance. Add a user to your account. Authorize a card for remote purchases';
            track(PRO_GET_POST_PAGE_ERROR, {
                displayType: 'inline',
                message: message,
                code: 'n/a',
                type: 'advisory',
                pageSection: PRO_ALLOWANCE_OVERLAY,
            });
            track(PRO_PAGE_LOAD, { pageName: 'no users no authorized' });
        }
    }, [
        addUserToAccount,
        addCreditCard,
        authorizeCard,
        addUserAndCreditCard,
        addUserAndAuthorizeCard,
    ]);
    return (React.createElement(React.Fragment, null,
        addUserToAccount && (React.createElement(Alert, { status: "warning" },
            React.createElement(Typography, { variant: "body-base" },
                "You need to",
                ' ',
                React.createElement(Link, { href: MANAGE_USERS_URL, onClick: function () {
                        track(PRO_GET_STATE, {
                            action_name: 'add user to your account link',
                        });
                    }, "data-testid": "add-user" }, "add a user to your account"),
                ' ',
                "to get started with Pro Allowance."))),
        authorizeCard && (React.createElement(Alert, { status: "warning" },
            React.createElement(Typography, { variant: "body-base" },
                "You need to",
                ' ',
                React.createElement(Link, { href: PAYMENTS_URL, onClick: function () {
                        track(PRO_GET_STATE, {
                            action_name: 'authorize a card for remote purchases link',
                        });
                    }, "data-testid": "authorize-card" }, "authorize a card for Remote Purchases"),
                ' ',
                "to get started with Pro Allowance.",
                ' ',
                React.createElement(Tooltip, { offset: "tight", title: 'On the Cards and Accounts page, click the action menu for the credit card you want to authorize and select "Remote Purchases."', "data-testid": "authorize-card-tooltip" },
                    React.createElement(InfoFilled, { color: "info", size: "small" }))))),
        addCreditCard && (React.createElement(Alert, { status: "warning" },
            React.createElement(Typography, { variant: "body-base" },
                "You need to",
                ' ',
                React.createElement(Link, { href: "/myaccount/payments/addcreditcard?fromProAllowance=true", onClick: function () {
                        track(PRO_GET_STATE, {
                            action_name: 'add credit card to your account link',
                        });
                    }, "data-testid": "add-card" },
                    ' ',
                    "add a credit card to your account"),
                ' ',
                "to get started with Pro Allowance."))),
        addUserAndCreditCard && (React.createElement(Alert, { status: "warning" },
            React.createElement(Typography, { variant: "body-base" },
                React.createElement("div", null, "You need to update your account to get started with Pro Allowance"),
                React.createElement("div", { className: "sui-list-disc sui-ml-4" },
                    React.createElement("li", null,
                        React.createElement(Link, { href: MANAGE_USERS_URL, onClick: function () {
                                track(PRO_GET_STATE, {
                                    action_name: 'add user to your account link',
                                });
                            }, "data-testid": "add-user-bullet-one" }, "Add a user to your account")),
                    React.createElement("li", null,
                        React.createElement(Link, { href: "/myaccount/payments/addcreditcard?fromProAllowance=true", onClick: function () {
                                track(PRO_GET_STATE, {
                                    action_name: 'add credit card to your account link',
                                });
                            }, "data-testid": "add-card-bullet" }, "Add a credit card to your account")))))),
        addUserAndAuthorizeCard && (React.createElement(Alert, { status: "warning" },
            React.createElement(Typography, { variant: "body-base" },
                React.createElement("div", null, "You need to update your account to get started with Pro Allowance"),
                React.createElement("div", { className: "sui-list-disc sui-ml-4" },
                    React.createElement("li", null,
                        React.createElement(Link, { href: MANAGE_USERS_URL, onClick: function () {
                                track(PRO_GET_STATE, {
                                    action_name: 'add user to your account link',
                                });
                            }, "data-testid": "add-user-bullet-two" }, "Add a user to your account")),
                    React.createElement("li", null,
                        React.createElement(Link, { href: PAYMENTS_URL, onClick: function () {
                                track(PRO_GET_STATE, {
                                    action_name: 'authorize a card for remote purchases link',
                                });
                            }, "data-testid": "authorize-card-bullet" }, "Authorize a card for remote purchases"),
                        ' ',
                        React.createElement(Tooltip, { offset: "tight", title: 'On the Cards and Accounts page, click the action menu for the credit card you want to authorize and select "Remote Purchases."', "data-testid": "authorize-card-tooltip-bullet" },
                            React.createElement(InfoFilled, { color: "info", size: "small" })))))))));
};
ProAllowMissingDataMsgs.displayName = 'ProAllowanceMissingDataMsgs';
